import { css } from 'styled-system/css'

// Matches the prototype's [data-tip]::after tooltip exactly (black bg, white
// text) rather than the app-wide AppTooltip's default light popover style.
export const promptTooltipClass = css({
  background: 'var(--colors-editorial-tip-bg) !important',
  color: 'var(--colors-editorial-tip-fg) !important',
  fontSize: '10.5px !important',
  fontWeight: '500 !important',
  padding: '5px 8px !important',
  borderRadius: '6px !important',
  boxShadow: '0 6px 16px rgba(0, 0, 0, 0.22) !important',
  whiteSpace: 'nowrap',
})
